export default __webpack_public_path__ + "static/media/af.9cf392c0.jpg";